import React from "react";
import { LystNewsArticleCard } from "web/react/components/lyst-news/lyst-news-article-card";
import { ArchiveDeviceDivider } from "web/react/emo/archive-device-divider/archive-device-divider";
import { Button } from "web/react/emo/button";
import { QuoteText } from "web/react/emo/quote-text";
import { NewsArticleBodySerializer, NewsArticleSerializer } from "web/types/serializers";
import * as styles from "./lyst-news-article.css";
import { LystNewsImage } from "./lyst-news-image";
import { LystNewsParagraph } from "./lyst-news-paragraph";
import { LystNewsVideoEmbed } from "./lyst-news-video-embed/lyst-news-video-embed";

const BODY_COMPONENT_MAP: Record<
    NewsArticleBodySerializer["type"],
    (props: { value: string }) => React.ReactElement
> = {
    paragraph: ({ value }) => <LystNewsParagraph text={value} />,
    image: ({ value }) => <LystNewsImage src={value} />,
    quote: ({ value }) => <QuoteText text={value} />,
    video: ({ value }) => <LystNewsVideoEmbed html={value} />,
};

export function LystNewsArticle({
    title,
    published_at,
    hero_image_url,
    body,
    next_page_url,
    previous_page_url,
}: NewsArticleSerializer): React.ReactElement {
    const renderBody = (): React.ReactNode[] => {
        return body.map(({ type, value }, index) => {
            const BodyComponent = BODY_COMPONENT_MAP[type];
            return <BodyComponent key={`${type}-${index}`} value={value as string} />;
        });
    };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.headerContainer}>
                <LystNewsArticleCard
                    imgSrc={hero_image_url}
                    title={title}
                    subtitle={published_at as string}
                    isHero
                />
            </div>
            <div className={styles.bodyContainer}>{renderBody()}</div>
            <ArchiveDeviceDivider />
            <div className={styles.adjacentArticlesContainer}>
                <Button
                    inactive={!previous_page_url}
                    icon="arrow-left"
                    title="Prev"
                    variant="tertiary"
                    href={previous_page_url ?? undefined}
                />
                <Button
                    inactive={!next_page_url}
                    icon="arrow-right"
                    iconPosition="right"
                    title="Next"
                    variant="tertiary"
                    href={next_page_url ?? undefined}
                />
            </div>
        </div>
    );
}
